module.exports = __webpack_public_path__ + "static/img/1.704dc69.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhongzaisheng/detail2/1.png
// module id = oRLD
// module chunks = 19